import { patchState, signalStoreFeature, type, withMethods } from '@ngrx/signals';
import { TableSignalState } from './table-signal-state';
import { Base } from '../model';

export function withCommonMethods<T extends Base<string>>() {
  return signalStoreFeature(
    { state: type<TableSignalState<T>>() },
    withMethods((store) => ({
      resetPageNumber(): void {
        patchState(store, (state) => ({ ...state }));
      },
    }))
  );
}
